var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 7.3125C1.1925 7.3125 0.9375 7.0575 0.9375 6.75V4.875C0.9375 2.7 2.7075 0.9375 4.875 0.9375H6.75C7.0575 0.9375 7.3125 1.1925 7.3125 1.5C7.3125 1.8075 7.0575 2.0625 6.75 2.0625H4.875C3.3225 2.0625 2.0625 3.3225 2.0625 4.875V6.75C2.0625 7.0575 1.8075 7.3125 1.5 7.3125Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.3125C16.1925 7.3125 15.9375 7.0575 15.9375 6.75V4.875C15.9375 3.3225 14.6775 2.0625 13.125 2.0625H11.25C10.9425 2.0625 10.6875 1.8075 10.6875 1.5C10.6875 1.1925 10.9425 0.9375 11.25 0.9375H13.125C15.2925 0.9375 17.0625 2.7 17.0625 4.875V6.75C17.0625 7.0575 16.8075 7.3125 16.5 7.3125Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 17.0625H12C11.6925 17.0625 11.4375 16.8075 11.4375 16.5C11.4375 16.1925 11.6925 15.9375 12 15.9375H13.125C14.6775 15.9375 15.9375 14.6775 15.9375 13.125V12C15.9375 11.6925 16.1925 11.4375 16.5 11.4375C16.8075 11.4375 17.0625 11.6925 17.0625 12V13.125C17.0625 15.3 15.2925 17.0625 13.125 17.0625Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 17.0625H4.875C2.7075 17.0625 0.9375 15.3 0.9375 13.125V11.25C0.9375 10.9425 1.1925 10.6875 1.5 10.6875C1.8075 10.6875 2.0625 10.9425 2.0625 11.25V13.125C2.0625 14.6775 3.3225 15.9375 4.875 15.9375H6.75C7.0575 15.9375 7.3125 16.1925 7.3125 16.5C7.3125 16.8075 7.0575 17.0625 6.75 17.0625Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 3.9375H5.25C4.395 3.9375 3.9375 4.3875 3.9375 5.25V6.75C3.9375 7.6125 4.395 8.0625 5.25 8.0625H6.75C7.605 8.0625 8.0625 7.6125 8.0625 6.75V5.25C8.0625 4.3875 7.605 3.9375 6.75 3.9375Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 3.9375H11.25C10.395 3.9375 9.9375 4.3875 9.9375 5.25V6.75C9.9375 7.6125 10.395 8.0625 11.25 8.0625H12.75C13.605 8.0625 14.0625 7.6125 14.0625 6.75V5.25C14.0625 4.3875 13.605 3.9375 12.75 3.9375Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9.9375H5.25C4.395 9.9375 3.9375 10.3875 3.9375 11.25V12.75C3.9375 13.6125 4.395 14.0625 5.25 14.0625H6.75C7.605 14.0625 8.0625 13.6125 8.0625 12.75V11.25C8.0625 10.3875 7.605 9.9375 6.75 9.9375Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.9375H11.25C10.395 9.9375 9.9375 10.3875 9.9375 11.25V12.75C9.9375 13.6125 10.395 14.0625 11.25 14.0625H12.75C13.605 14.0625 14.0625 13.6125 14.0625 12.75V11.25C14.0625 10.3875 13.605 9.9375 12.75 9.9375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionQr);
export default __webpack_public_path__ + "static/media/action-qr.e7a73dcb0c0d23ccadaee3640337faaa.svg";
export { ForwardRef as ReactComponent };